import axios from 'axios'
import ApiService from './api.service'
const InspectorService = {
  Get(certificateNumber) {
    if (certificateNumber)
      return ApiService.get(
        `/Inspector/Get?certificateNumber=${certificateNumber}`
      );
    else return ApiService.get(`/Inspector/Get`);
  },
  GetAsSelectList(data) {
    return ApiService.post(`/Inspector/GetAsSelectList`, data);
  },
  GetPersonPhoto(data) {
    return axios.post(`/Inspector/GetPersonPhoto`, data, {
      responseType: 'blob',
    });
  },
};
export default InspectorService